// @flow
import React from 'react';
import { SecurityHelper, Text } from 'sarsaparilla';
import IsGuidedQuestion from '../IsGuidedQuestion';
import { COMMERCIAL_BOOKING_TEXT } from '../../utils/inyoUtils';

type PropTypes = {
    contactAgency: string,
    setQuestionnaireAnswers: Function,
};

export default function CommercialQuestion({
    contactAgency,
    setQuestionnaireAnswers,
}: PropTypes) {
    const handleIsCommercialGuided = (event) => {
        setQuestionnaireAnswers({
            contactAgency: event.target.value,
        });
    };

    return SecurityHelper.isCommercialAccount() ? (
        <Text>{COMMERCIAL_BOOKING_TEXT}</Text>
    ) : (
        <IsGuidedQuestion
            contactAgency={contactAgency}
            handleAnswerChange={handleIsCommercialGuided}
        />
    );
}
